import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AttributesService {
  private endpoints = {
    sdkAttrs: '/dashboard/attrs/v1',
    evtAttrs: '/dashboard/ujmanalytics/vendor/eventattributes'
  };
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) { }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  getAttributes(appId: string) {
    const endPoint = this.endpoints.sdkAttrs;
    const dataToSend = {
      'params' : {
        aid: appId
      }
    };
    return this.http.get<any>(endPoint, { ...this.httpOptions, ...dataToSend }).pipe(
      map(this.extractData)
    );
  }

  getEventAttributes(vendorId: string, eventName: string, appId?: string) {
    const endPoint = this.endpoints.evtAttrs;
    const dataToSend = {
      'params': {
        vid: vendorId,
        en: eventName,
        aid: appId
      }
    };
    return this.http.get<any>(endPoint, { ...this.httpOptions, ...dataToSend }).pipe(
      map(this.extractData)
    );
  }

}
